<template>
  <div class="mask-content">
    <van-tabs v-model="active" animated sticky @click="tabClick">
      <van-tab v-for="(item,index) in tabs" :title="item" :key="index">
        <template v-if="couponList && couponList.length !== 0">
          <div
          class="coupon-item"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <div class="flex-1 con">
            <div class="left">
              <span class="title">{{ item.name }}</span>
              <span class="time">有效期至{{ item.endTime }}</span>
            </div>
            <div class="right">
              <span class="price">{{ item.denomination }}</span>
              <span v-if="item.category == 1">满{{ item.fullNumber }}可用</span>
              <span v-if="item.category == 0">无门槛使用</span>
            </div>

            <div class="circle l"></div>
            <div class="circle r"></div>
          </div>

          <div class="con">
            <div class="left"></div>
            <div v-if="item.used" class="right getEd">已使用</div>
            <div v-if="!item.used" class="right get">可使用</div>
            
          </div>
        </div>
        </template>
        <van-empty description="空空如也" v-else/>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      couponList: [],
      tabs:['未使用','已使用','已失效'],
      active:0,
    };
  },
  mounted() {
    this.getCouponList({used:false});
  },
  methods: {
    getCouponList(params) {
      this.$http.request(this.$http.pathMap.couponOwnList,'get',params).then((res) => {
        console.log(res.data);
        this.couponList = res.data;
      });
    },
    tabClick(name) {
      if(name === 0) {
        this.getCouponList({used:false})
      }else if(name === 1){
        this.getCouponList({used:true,expire:0})
      }else {
        this.getCouponList({expire:1})
      }
    }
  },
};
</script>
<style lang="scss" scoped>
/* 优惠券列表 */
.mask-content {
  width: 100%;
}
.coupon-item {
  display: flex;
  flex-direction: column;
  margin: 10px 12px;
  background: #fff;

  .con {
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px 15px;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #f3f3f3;
      transform: scaleY(50%);
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    overflow: hidden;
  }

  .title {
    font-size: 16px;
    color: $font-color-dark;
    margin-bottom: 5px;
  }

  .time {
    font-size: 12px;
    color: $font-color-light;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 13px;
    color: $font-color-base;
  }
  .get {
    background-color: var(--theme-font-color);
    color: white;
    padding: 2px 10px;
    border-radius: 50px;
  }
  .getEd {
    background-color: grey;
    color: white;
    padding: 2px 10px;
    border-radius: 50px;
  }

  .price {
    font-size: 22px;
    color: $base-color;

    &:before {
      content: "￥";
      font-size: 17px;
    }
  }

  .tips {
    font-size: 12px;
    color: $font-color-light;
    line-height: 30px;
    padding-left: 30px;
  }

  .circle {
    position: absolute;
    left: -3px;
    bottom: -5px;
    z-index: 10;
    width: 10px;
    height: 10px;
    background: #f3f3f3;
    border-radius: 100px;

    &.r {
      left: auto;
      right: -3px;
    }
  }
}
.checkbox {
  font-size: 22px;
  line-height: 1;
  padding: 2px;
  color: $font-color-disabled;
  background: #fff;
  border-radius: 50px;
}
</style>
